import { Image } from 'antd';
import { GlobalContext } from 'context';
import { useContext } from 'react';
import { IoCheckmarkDoneOutline } from 'react-icons/io5';
import { MdOutlineAttachFile, MdOutlineAudioFile, MdOutlineVideoFile } from 'react-icons/md';
import { AttachmentTypeEnum, MessageStatusType, MessageType } from 'types';
import { COLORS } from 'utilities';

const defaultImg =
    'data:image/png;base64,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';

function MessageCardComp({ className, data }: { className: string; data: MessageType }) {
    const { profile } = useContext(GlobalContext);
    const targetDate = new Date(data.created_at);
    const hours = targetDate.getHours();
    const minutes = targetDate.getMinutes();
    const isAudio = data.text === '____ALOEJARE_VOICE_MESSAGE____';
    return (
        <div className={`${className} ${isAudio ? 'w-100-i' : ''} mb-2`}>
            {isAudio && data.file.length === 1 ? (
                <audio style={{ minWidth: 0, width: '100%' }} src={data.file.at(0)?.file} controls></audio>
            ) : (
                <>
                    <p className="t-400 t-p2 mb-1">{data.text}</p>
                    <div style={{ flexWrap: 'wrap' }} className="d-flex mv-1">
                        {data.file.map((file) => (
                            <div
                                key={file.id}
                                style={{
                                    height: 100,
                                    minWidth: 100,
                                    maxWidth: 200,
                                    borderRadius: '10px',
                                    overflow: 'hidden',
                                    gap: 12,
                                }}
                                className="flex-1"
                            >
                                {file.type === AttachmentTypeEnum.image ? (
                                    <Image
                                        width={'100%'}
                                        height={100}
                                        src={file.file}
                                        fallback={defaultImg}
                                        preview={{ mask: false }}
                                        style={{ objectFit: 'cover' }}
                                    />
                                ) : (
                                    <div
                                        className="center-content"
                                        style={{ height: 100, backgroundColor: '#dddddd', flexDirection: 'column' }}
                                        onClick={() => window.open(file.file, '_blank')}
                                    >
                                        {file.type === AttachmentTypeEnum.audio ? (
                                            <MdOutlineAudioFile size={20} className="mb-1" />
                                        ) : file.type === AttachmentTypeEnum.archive ? (
                                            <MdOutlineAttachFile size={20} className="mb-1" />
                                        ) : file.type === AttachmentTypeEnum.document ? (
                                            <MdOutlineAttachFile size={20} className="mb-1" />
                                        ) : file.type === AttachmentTypeEnum.video ? (
                                            <MdOutlineAttachFile size={20} className="mb-1" />
                                        ) : (
                                            <MdOutlineVideoFile size={20} className="mb-1" />
                                        )}
                                        <p className="t-p4">
                                            {file.type === AttachmentTypeEnum.audio
                                                ? 'فایل صوتی'
                                                : file.type === AttachmentTypeEnum.archive
                                                  ? 'فایل فشرده'
                                                  : file.type === AttachmentTypeEnum.document
                                                    ? 'فایل متنی'
                                                    : file.type === AttachmentTypeEnum.video
                                                      ? 'فایل ویدیویی'
                                                      : 'فایل پیوست'}
                                        </p>
                                    </div>
                                )}
                            </div>
                        ))}
                        <span
                            style={{
                                minWidth: 100,
                                borderRadius: '10px',
                                overflow: 'hidden',
                                maxWidth: 200,
                                gap: 12,
                            }}
                            className="flex-1"
                        ></span>
                        <span
                            style={{
                                minWidth: 100,
                                borderRadius: '10px',
                                overflow: 'hidden',
                                maxWidth: 200,
                                gap: 12,
                            }}
                            className="flex-1"
                        ></span>
                    </div>
                </>
            )}
            <p className={`t-300 center-content-y`}>
                {data.status === MessageStatusType.read && data.user.id === profile?.id && (
                    <IoCheckmarkDoneOutline
                        size={10}
                        color={COLORS.primary}
                        style={{ marginLeft: '2px', marginBottom: '5px' }}
                    />
                )}
                {hours < 10 ? `0${hours}` : hours}:{minutes < 10 ? `0${minutes}` : minutes}
            </p>
        </div>
    );
}

export default MessageCardComp;
